import { CheckCircle, Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const AvailabilityBadge = () => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 animate-fade-in">
      {/* Available immediately badge */}
      <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-emerald-500/10 border border-emerald-500/30 backdrop-blur-sm">
        <span className="relative flex h-2 w-2 sm:h-2.5 sm:w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 sm:h-2.5 sm:w-2.5 bg-emerald-500"></span>
        </span>
        <span className="text-xs sm:text-sm font-medium text-emerald-600 dark:text-emerald-400">
          {t("hero.available")}
        </span>
        <CheckCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-500" />
      </div>

      {/* Actively looking badge */}
      <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-primary/8 border border-primary/20 backdrop-blur-sm">
        <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary animate-pulse" />
        <span className="text-xs sm:text-sm font-medium text-muted-foreground">
          {t("hero.seeking")}
        </span>
      </div>
    </div>
  );
};

export default AvailabilityBadge;
